module.exports = __webpack_public_path__ + "static/media/Ishan Patwardhan.80acf16d.png";